module.exports = __webpack_public_path__ + "static/media/logo-mobile.b342a6ba.svg";